import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ResultsCarouselProps {
  className?: string;
  variant?: 'advertorial' | 'product';
}
export const ResultsCarousel: React.FC<ResultsCarouselProps> = ({
  className,
  variant = 'advertorial'
}) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  // Define slides based on variant
  const slides = variant === 'advertorial' ? [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3ZXgeHx6VNpz4UnHTrveMz/Gemini_Generated_Image_c9z1nrc9z1nrc9z1.jpg',
    alt: 'Voor en na haartransformatie met dramatische verbetering in gladheid en glans'
  }] : [{
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aYwUxarwJE1KLNyrKGQPQb/Gemini_Generated_Image_da98zyda98zyda98.jpg',
    alt: 'Zij-aan-zij vergelijking van pluizig beschadigd haar versus glad, gezond haar na QISS-behandeling'
  }, {
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fYvx7JkrDD5oXpqgcDRyrb/Gemini_Generated_Image_5o3os75o3os75o3o.jpg',
    alt: 'Schuine weergave voor en na met transformatie van droog, beschadigd haar naar glad, glanzend haar'
  }];
  const nextSlide = () => {
    setCurrentSlide(prev => prev === slides.length - 1 ? 0 : prev + 1);
  };
  const prevSlide = () => {
    setCurrentSlide(prev => prev === 0 ? slides.length - 1 : prev - 1);
  };
  return <div className={`relative ${className}`} data-id="element-69">
      <div className="overflow-hidden rounded-lg" data-id="element-70">
        <div className="relative" data-id="element-71">
          <img src={slides[currentSlide].image} alt={slides[currentSlide].alt} className="w-full h-auto rounded-lg" data-id="element-72" />
          {/* Navigation dots - only show if more than one slide */}
          {slides.length > 1 && <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2" data-id="element-73">
              {slides.map((_, index) => <button key={index} onClick={() => setCurrentSlide(index)} className={`w-2.5 h-2.5 rounded-full ${currentSlide === index ? 'bg-pink-600' : 'bg-gray-300'}`} aria-label={`Ga naar slide ${index + 1}`} data-id="element-74" />)}
            </div>}
        </div>
      </div>
      {/* Navigation arrows - only show if more than one slide */}
      {slides.length > 1 && <>
          <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-1.5 shadow-md hover:bg-white" aria-label="Vorige slide" data-id="element-75">
            <ChevronLeftIcon className="w-5 h-5 text-gray-700" data-id="element-76" />
          </button>
          <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/80 rounded-full p-1.5 shadow-md hover:bg-white" aria-label="Volgende slide" data-id="element-77">
            <ChevronRightIcon className="w-5 h-5 text-gray-700" data-id="element-78" />
          </button>
        </>}
    </div>;
};